import { client } from 'shared';

export async function getWorkerHistory(providerUserId: number | undefined) {
    return client(`api/worker-history/${providerUserId}/`);
}
